import React from 'react'
import { Box } from '@mui/material'
import { __t } from '../../../../../i18n/t'
import { allOpts, brl, collisions, defaultOptsText, joinList, ptsOf } from '../../model'
import { useWiz } from '../../state/WizardContext'
import { Ask, Callout } from '../../ui/basics'
import { RadioCard, RadioRow } from '../../ui/controls'

const trapSx = { maxWidth: 760, fontSize: 13.5 } as const

/** Só aparece quando a promoção bate com um Padrão que já existe no mesmo posto e combustível. Padrão: mostrar as duas. */
export const OverlapSection: React.FC = () => {
  const { d, c, set } = useWiz()
  const cols = collisions(d, c)
  if (!cols.length) return null
  const byCode: Record<string, { where: string; list: string[] }> = {}
  cols.forEach(x => { (byCode[x.code] = byCode[x.code] || { where: x.where, list: [] }).list.push(`${x.fuel} ${defaultOptsText(x.opts)}`) })
  const trap = d.overlap && allOpts(d, c).some(o => ptsOf(d, o) > 0)
  return (
    <Ask
      id="h-overlap"
      title={__t('Já existe um Padrão nesses postos')}
      help={Object.keys(byCode).map(code => __t('O %{codigo} já dá, por litro, %{lista} no %{onde}.', { codigo: code, lista: joinList(byCode[code].list), onde: byCode[code].where })).join(' ')}
    >
      <RadioRow labelledBy="h-overlap">
        <RadioCard
          name="overlap"
          checked={!d.overlap}
          onChange={() => set(x => ({ ...x, overlap: false }))}
          title={__t('Mostrar as duas opções (recomendado)')}
          desc={__t('O app marca o de maior desconto.')}
        />
        <RadioCard
          name="overlap"
          checked={d.overlap}
          onChange={() => set(x => ({ ...x, overlap: true }))}
          title={__t('Mostrar só a promoção')}
          desc={__t('O Padrão some para quem recebe a promoção.')}
        />
      </RadioRow>
      <Box role="status">
        {trap ? <Callout tone="warn" role="presentation" sx={trapSx}>{__t('Quem não tiver pontos para a promoção fica sem nenhum desconto nesses combustíveis.')}</Callout> : null}
      </Box>
    </Ask>
  )
}
